import { APICore } from "./api.core";
import {
  IDepartmentHeadPayLoad,
  IInstitutionHeadPayload,
} from "../pages/Users/core/models";
import { SignInForm, SignUpForm } from "../pages/Auth/core/models";
import {
  IChangePassword,
  UserProfileUpdate,
} from "../pages/Settings/core/models";
import { IDevicePayload } from "../pages/Devices/core/models";
import {
  IAssetPayload,
  IAssignPayload,
  IAssetCategory,
} from "../pages/Assets/core/models";

const api = new APICore();
// ================ begin auth endpoints ===================

export const SignIn = async (body: SignInForm) => {
  const response = await api.postAPI("/api/user/login", body);

  const { status, message, data } = response.data;
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SignUp = async (body: SignUpForm) => {
  const response = await api.postAPI("/api/user/signup", body);

  const { status, message, data } = response.data;
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const ProfileUpdate = async (body: UserProfileUpdate) => {
  const response = await api.patchAPI("/api/user/updateProfile", body);

  const { status, message, data } = response.data;
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const PasswordUpdate = async (body: IChangePassword) => {
  const response = await api.patchAPI("/api/user/updatePassword", body);

  const { status, message, data } = response.data;
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const deleteAccount = async () => {
  const response = await api.deleteAPI("/api/user/deleteAccount");

  const { status, message, data } = response.data;
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

// ================ end auth endpoints ===================

// ================ begin user endpoints ===================
export const SGetUsers = async (id: string, params?: any) => {
  const { status, message, data } = await api
    .getAPI(`/api/user/${id}/external`, { params })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return data.docs;
};

export const SCreateUser = async (
  body: IInstitutionHeadPayload | IDepartmentHeadPayLoad,
) => {
  const { status, message, data } = await api
    .postAPI("/api/user", body)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SUpdateUser = async (update: {
  userId: string;
  body: IInstitutionHeadPayload | IDepartmentHeadPayLoad;
}) => {
  const { status, message, data } = await api
    .patchAPI(`/api/user/${update.userId}`, update.body)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};
export const updateUserPassword = async (queryData: {
  userId: string;
  password: string;
}) => {
  const { status, message, data } = await api
    .patchAPI(`/api/user/userUpdatePassword`, queryData)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const deleteUser = async (userId: string) => {
  const { status, message } = await api
    .deleteAPI(`/api/user/${userId}`)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message };
};

// ================ end user endpoints ===================

// ================ begin interview endpoints ==================

export const getInterviews = async () => {
  const { status, message, data } = await api
    .getAPI("/api/interview")
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return data.docs;
};
export const createInterview = async (body: FormData) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  const { status, message, data } = await api
    .postAPI("/api/interview", body, config)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const updateInterview = async (params: {
  interviewId: string;
  body: FormData;
}) => {
  const { interviewId, body } = params;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  const { status, message, data } = await api
    .patchAPI(`/api/interview/${interviewId}`, body, config)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const deleteInterview = async (interviewId: string) => {
  const { status, message, data } = await api
    .deleteAPI(`/api/interview/${interviewId}`)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

// ================ end interview endpoints ===================

// ================ begin device endpoints ==================

export const SCreateDevice = async (body: IDevicePayload) => {
  const { status, message, data } = await api
    .postAPI("/api/device", body)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SUpdateDevice = async (params: {
  deviceId: string;
  body: any;
}) => {
  const { status, message, data } = await api
    .patchAPI(`/api/device/${params.deviceId}`, params.body)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const getDevices = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/device", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return data.docs;
};

export const SDeleteDevice = async (deviceId: string) => {
  const { status, message, data } = await api
    .deleteAPI(`/api/device/${deviceId}`)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message };
};
// ================ end report endpoints ==================

// ================ begin report endpoints ===================
export const getReportData = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/report", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return data.docs;
};

export const createNewReport = async (body: FormData) => {
  const { status, message, data } = await api
    .postAPI("/api/report", body, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const updateReport = async (params: {
  reportId: string;
  body: FormData;
}) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  const { status, message, data } = await api
    .patchAPI(`/api/report/${params.reportId}`, params.body, config)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const deleteReport = async (reportId: string) => {
  const { status, message } = await api
    .deleteAPI(`/api/report/${reportId}`)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message };
};

// ================ end report endpoints ===================

// ================ begin kobo endpoints ===================
export const SGetKoboProjects = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/kobo", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return data;
};

export const SGetKoboProjectById = async (projectId: string) => {
  const { status, message, data } = await api
    .getAPI(`/api/kobo/${projectId}`)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SCreateKoboProject = async (body: any) => {
  const { status, message, data } = await api
    .postAPI("/api/kobo", body)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SUpdateKoboProject = async (params: {
  projectId: string;
  body: any;
}) => {
  const { status, message, data } = await api
    .patchAPI(`/api/kobo/${params.projectId}`, params.body)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SToggleKoboAnalytics = async (
  projectId: string,
  showInAnalytics: boolean,
) => {
  const { status, message, data } = await api
    .patchAPI(`/api/kobo/${projectId}`, { showInAnalytics })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SUpdateKoboColumnMappings = async (
  projectId: string,
  columnMappings: {
    satisfactionColumn?: string;
    waitingTimeColumn?: string;
    locationColumn?: string;
    departmentColumn?: string;
  },
) => {
  const { status, message, data } = await api
    .patchAPI(`/api/kobo/${projectId}`, { columnMappings })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SDeleteKoboProject = async (projectId: string) => {
  const { status, message } = await api
    .deleteAPI(`/api/kobo/${projectId}`)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message };
};

export const SFetchKoboData = async (projectId: string, query?: any) => {
  const { status, message, data } = await api
    .getAPI(`/api/kobo/${projectId}/data`, { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetKoboAssetDetails = async (projectId: string) => {
  const { status, message, data } = await api
    .getAPI(`/api/kobo/${projectId}/asset`)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SSyncKoboProjects = async (body: { institution?: string }) => {
  const { status, message, data } = await api
    .postAPI("/api/kobo/sync", body)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};
// ================ end kobo endpoints ====================

// ================ begin USSD endpoints ===================
export const SGetUssdResponses = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/ussd", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetUssdResponseById = async (id: string) => {
  const { status, message, data } = await api
    .getAPI(`/api/ussd/${id}`)
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetUssdStatistics = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/ussd/statistics", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetUssdServiceNames = async () => {
  const { status, message, data } = await api
    .getAPI("/api/ussd/institutions")
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetUssdOffices = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/ussd/offices", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetUssdRatingTrends = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/ussd/rating-trends", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetUssdWaitingTimeTrends = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/ussd/waiting-time-trends", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetUssdOrganizationStats = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/ussd/organization-stats", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};
// ================ end USSD endpoints ===================

// ================ Kobo Organizations endpoint ===================
export const SGetKoboSurveys = async () => {
  const { status, message, data } = await api
    .getAPI("/api/kobo/surveys/list")
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetKoboOrganizations = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/kobo/organizations/list", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetKoboRatingTrends = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/kobo/rating-trends", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetKoboWaitingTimeTrends = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/kobo/waiting-time-trends", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetDeviceRatingTrends = async (query?: any) => {
  console.log("📊 Fetching device rating trends with query:", query);
  const { status, message, data } = await api
    .getAPI("/api/feedback/rating-trends", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  console.log("✅ Device rating trends data:", data);
  return { message, data };
};

export const SGetDeviceInstitutions = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/feedback/institutions", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetDeviceOrganizationStats = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/feedback/organization-stats", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetKoboDepartmentSatisfaction = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/kobo/department-satisfaction", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetKoboRatingDistribution = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/kobo/rating-distribution", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

export const SGetKoboOrganizationStats = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/kobo/organization-stats", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return { message, data };
};

/**
 * Sync Kobo analytics data to cache (with streaming logs via EventSource)
 */
export const SSyncKoboAnalytics = (
  startDate: string,
  endDate: string,
  onLog: (log: { type: string; message: string; timestamp: string }) => void,
  onComplete: () => void,
  onError: (error: string) => void,
) => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("talktosema_user");

  const url = `${baseURL}/api/kobo/analytics/sync`;

  // Use fetch with streaming response
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ startDate, endDate }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body?.getReader();
      const decoder = new TextDecoder();

      const readStream = () => {
        reader?.read().then(({ done, value }) => {
          if (done) {
            onComplete();
            return;
          }

          const chunk = decoder.decode(value, { stream: true });
          const lines = chunk.split("\n");

          lines.forEach((line) => {
            if (line.startsWith("data: ")) {
              const data = line.substring(6).trim();

              if (data === "[DONE]") {
                onComplete();
                return;
              }

              try {
                const logEntry = JSON.parse(data);
                onLog(logEntry);
              } catch (e) {
                console.error("Failed to parse log entry:", data);
              }
            }
          });

          readStream();
        });
      };

      readStream();
    })
    .catch((error) => {
      onError(error.message);
    });
};

// ================ begin qrcode endpoints ===================
export const SUploadQRLogo = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("logo", file);
  const response = await api.postAPI("/api/qrcode/upload-logo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const { status, message, data } = response.data;
  if (status !== "success") throw new Error(message);
  return data.url as string;
};

export const SDeleteQRLogo = async (url: string): Promise<void> => {
  const response = await api.deleteAPI("/api/qrcode/logo", { data: { url } });
  const { status, message } = response.data;
  if (status !== "success") throw new Error(message);
};
// ================ end qrcode endpoints ===================

// ================ begin asset endpoints ===================
export const getAssets = async (query?: any) => {
  const { status, message, data } = await api
    .getAPI("/api/asset", { params: query })
    .then((res) => res.data);

  if (status !== "success") {
    throw new Error(message);
  }

  return data.docs;
};

export const SCreateAsset = async (body: IAssetPayload) => {
  const { status, message, data } = await api
    .postAPI("/api/asset", body)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SUpdateAsset = async (params: { assetId: string; body: any }) => {
  const { status, message, data } = await api
    .patchAPI(`/api/asset/${params.assetId}`, params.body)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SDeleteAsset = async (assetId: string) => {
  const { status, message } = await api
    .deleteAPI(`/api/asset/${assetId}`)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message };
};

export const SAssignAsset = async (params: {
  assetId: string;
  body: IAssignPayload;
}) => {
  const { status, message, data } = await api
    .postAPI(`/api/asset/${params.assetId}/assign`, params.body)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SUnassignAsset = async (assetId: string) => {
  const { status, message, data } = await api
    .postAPI(`/api/asset/${assetId}/unassign`, {})
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SBulkImportAssets = async (assets: IAssetPayload[]) => {
  const { status, message, data } = await api
    .postAPI("/api/asset/bulk-import", { assets })
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};
// ================ end asset endpoints ===================

// ================ begin asset category endpoints ===================
export const getAssetCategories = async (): Promise<IAssetCategory[]> => {
  const { status, message, data } = await api
    .getAPI("/api/asset-category")
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return data;
};

export const SCreateAssetCategory = async (body: {
  name: string;
  prefix?: string;
}) => {
  const { status, message, data } = await api
    .postAPI("/api/asset-category", body)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SUpdateAssetCategory = async (params: {
  categoryId: string;
  body: { name?: string; prefix?: string };
}) => {
  const { status, message, data } = await api
    .patchAPI(`/api/asset-category/${params.categoryId}`, params.body)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message, data };
};

export const SDeleteAssetCategory = async (categoryId: string) => {
  const { status, message } = await api
    .deleteAPI(`/api/asset-category/${categoryId}`)
    .then((res) => res.data);
  if (status !== "success") {
    throw new Error(message);
  }
  return { message };
};
// ================ end asset category endpoints ===================
